var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconX = function SvgIconX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M18.826 3.189a.5.5 0 0 1 .055.705l-5.229 6.114 6.939 10.055a.5.5 0 0 1-.412.784h-4.278a.5.5 0 0 1-.413-.217l-4.991-7.287L4.2 20.755a.5.5 0 0 1-.762-.648l6.472-7.619-5.916-8.637a.5.5 0 0 1 .413-.782h4.194a.5.5 0 0 1 .412.216l4.05 5.871 5.057-5.912a.5.5 0 0 1 .705-.055m-13.47.88 10.808 15.778h3.063L8.34 4.07z",
    clipRule: "evenodd"
  })));
};
export default SvgIconX;